import { gql } from '@apollo/client';
import { BASE_PARTNER_COMPANY_FRAGMENT } from './partner.fragments';
import { GEO_DATA_ISSUE } from './geoData.fragments';

export const DATASET_TABLE_REPRESENTATION_CELL_FRAGMENT = gql`
  fragment datasetTableRepresentationCellValues on DatasetCell {
    value
    error {
      entityId
      entityType
      errorMessage
    }
  }
`;

export const DATASET_TABLE_REPRESENTATION_FRAGMENT = gql`
  fragment datasetTableRepresentationValues on DatasetTableRepresentation {
    columnsNames
    rows {
      farmName {
        ...datasetTableRepresentationCellValues
      }
      farmId {
        ...datasetTableRepresentationCellValues
      }
      coordinates {
        ...datasetTableRepresentationCellValues
      }
      farmSizeHa {
        ...datasetTableRepresentationCellValues
      }
      originClusterId {
        ...datasetTableRepresentationCellValues
      }
      numberOfFarmers {
        ...datasetTableRepresentationCellValues
      }
      additionalCrops {
        ...datasetTableRepresentationCellValues
      }
      landOwnership {
        ...datasetTableRepresentationCellValues
      }
      farmOwnerFullName {
        ...datasetTableRepresentationCellValues
      }
      farmOwnerFirstName {
        ...datasetTableRepresentationCellValues
      }
      farmOwnerLastName {
        ...datasetTableRepresentationCellValues
      }
      siteDescription {
        ...datasetTableRepresentationCellValues
      }
    }
  }
  ${DATASET_TABLE_REPRESENTATION_CELL_FRAGMENT}
`;

export const GEOC_BATCH = gql`
  fragment geocBatchValues on GeocBatch {
    id
    createdTimestamp
    modifiedTimestamp
    externalBatchId
    geocBatchId
    weight
    riskStatus
    checkDate
    geoDataProcessId
  }
`;

export const DATASET_COLUMN_MAPPING_FRAGMENT = gql`
  fragment datasetColumnMappingValues on ColumnsData {
    columnName
    columnDataExample
    mappedColumnName
  }
`;

export const BASE_DATASET = gql`
  fragment baseDatasetValues on Dataset {
    id
    createdTimestamp
    modifiedTimestamp
    createdById
    title
    originCountry
    ownedBy {
      ...basePartnerCompanyValues
    }
    rawMaterial {
      id
      title
      hsCodes {
        id
        code
        description
      }
      eudrMaterialType
    }
    status
    issues {
      ...geoDataIssueValues
    }
    riskStatus
    originalGeoDataId
  }
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${GEO_DATA_ISSUE}
`;

export const DATASET_FRAGMENT = gql`
  fragment datasetValues on Dataset {
    ...baseDatasetValues
    documents {
      id
      title
    }
  }
  ${BASE_DATASET}
`;

export const DATASET_PROCESSING_ERROR_FRAGMENT = gql`
  fragment datasetProcessingErrorValues on DatasetProcessingError {
    datasetId
    datasetErrors {
      entityId
      entityType
      errorMessage
    }
    hasCellErrors
  }
`;
